import styled from 'react-emotion'

const TableCell = styled('td')(({ header }) => ({
    fontFamily: 'Montserrat, sans-serif',
    padding: header ? '5px 20px' : '15px 20px',
    textTransform: header && 'uppercase',
    color: '#444',
    fontWeight: 700,
    fontSize: header ? 12 : 18,
    textAlign: 'center',
    ':first-of-type': {
        textAlign: 'left'
    },
    ':nth-of-type(2)': {
        textAlign: 'left'
    },
    ':last-of-type': {
        textAlign: 'right'
    },
    '@media (max-width: 500px)': {
        fontSize: 13,
        padding: '15px 10px',
    }
}))

export default TableCell


// WEBPACK FOOTER //
// ./src/components/TableCellComponent.jsx